export const Tabs = {
	Description: 'description',
	WorkItems: 'workItems',
	Resources: 'resources',
	Integrations: 'integrations',
} as const;

export const defaultActiveTab = Tabs.Description;
